import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CloseIcon from '@mui/icons-material/Close';

const CustomSnackbar = React.forwardRef(({ id, closeSnackbar }, ref) => (
    <Box
        ref={ref}
        sx={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#fff',
            boxShadow: 3,
            borderRadius: 2,
            borderLeft: '6px solid #4CAF50',
            padding: '12px 16px',
            minWidth: 300,
        }}
    >
        <TaskAltIcon sx={{ color: '#4CAF50', fontSize: 24, mr: 1.5 }} />
        <Typography variant="body2" sx={{ flexGrow: 1 }}>
            DIDs have been exported successfully.
        </Typography>
        <IconButton size="small" onClick={() => closeSnackbar(id)}>
            <CloseIcon fontSize="small" />
        </IconButton>
    </Box>
));

export default CustomSnackbar;
